import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-blank-page',
  templateUrl: './blank-page.component.html',
  styleUrls: []
})
export class BlankPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
